import React, { useContext, useEffect, useState, useCallback } from "react";

import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import { callApi, getDwk, isEmpty, timeFormat, blockEmoji } from "bodycodi/cmap/app/js/common";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import { ApMember } from "./member";
import Pass from "bodycodi/cmap/app/components/common/pass";
import {
  AbsentConfirm,
  AppoinBtnPop,
  AttendanceConfirm,
  RsrvCancleConfirm,
} from "./scheduleAttendanceStep";
import Memo from "bodycodi/cmap/app/components/common/Memo";

const AppointmentDtlPop = () => {
  const { state } = useContext(HomeStateContext);
  const { dispatch } = useContext(DispatchContext);
  const [openPass, setOpenPass] = useState(false);
  const [scheduleData, setScheduleData] = useState<any>({
    ScheduleVO: {},
    PassVO: {},
  });
  const [memoReadOnly, setMemoReadOnly] = useState<string>("");
  const [ReservationSetting, setReservationSetting] = useState({});
  const [refresh, setRefresh] = useState(1);
  const { ScheduleVO, PassVO } = scheduleData;
  const startDate = new Date(ScheduleVO.startDate?.split(" ")[0]);
  const startDateText = startDate?.getMonth() + 1 + ". " + startDate.getDate();
  const startTime = timeFormat(ScheduleVO.startDate?.split(" ")[1].substring(0, 5));
  const endTime = timeFormat(ScheduleVO.endDate?.split(" ")[1].substring(0, 5));
  const [attendanceState, setAttendanceState] = useState("");

  useEffect(() => {
    callApi(
      "/cmap2020/viewAppointmentScheduleDtl",
      {
        seqPartner: state.scheduleDtlPop.seqPartner,
        seqPartnerBranch: state.scheduleDtlPop.seqPartnerBranch,
        seqPartnerCoach: state.scheduleDtlPop.seqPartnerCoach,
        seqSchedule: state.scheduleDtlPop.seqSchedule,
        scheduleType: state.scheduleDtlPop.scheduleType,
      },
      "GET"
    ).then((res) => {
      setScheduleData({ ...scheduleData, ...res });
      setMemoReadOnly(res.ScheduleVO.memo);
    });
    callApi(
      "/cmap2020/viewAttendancePrcs",
      {
        seqPartner: state.scheduleDtlPop.seqPartner,
        seqPartnerBranch: state.scheduleDtlPop.seqPartnerBranch,
        seqPartnerCoach: state.scheduleDtlPop.seqPartnerCoach,
        seqSchedule: state.scheduleDtlPop.seqSchedule,
        scheduleType: state.scheduleDtlPop.scheduleType,
      },
      "GET"
    ).then((res) => {
      setReservationSetting(res.ReservationSettingVO);
    });
  }, [refresh]);

  const update = useCallback(() => {
    setRefresh(refresh + 1);
  }, [refresh]);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_DTL_POP", open: { scheduleDtlPop: false } });
  };

  const handleOpenAttendance = () => {
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_BTN_POP", open: { apScheduleBtnPop: true } });
  };

  const handleOpenCancel = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "RSRV_CANCLE_CONFIRM_POP",
      open: { rsrvCancleConfirmPop: true },
    });
  };

  const handleClickMemoPop = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_SCHEDULE_TYPE",
      open: { memoEditPop: true },
    });
  };

  const handleChangeMemo = (memo: string) => {
    setScheduleData((previousValue: any) => ({
      ...previousValue,
      ScheduleVO: {
        ...previousValue.ScheduleVO,
        memo: blockEmoji(memo),
      },
    }));
  };

  const handleClickUpdateMemo = () => {
    callApi(
      "/cmap2020/execScheduleMemoUpd",
      { seqSchedule: ScheduleVO.seqSchedule, memo: ScheduleVO.memo },
      "POST"
    ).then((res) => {
      setMemoReadOnly(ScheduleVO.memo);
      dispatch({
        type: "POP_UP_OPEN",
        id: "CHOOSE_SCHEDULE_TYPE",
        open: { memoEditPop: false },
      });
      dispatch({ type: "UPDATE", data: { toast: true, toastText: "수정되었습니다." } });
    });
  };

  return (
    <>
      <PopupHeader onClickBack={handleClose} title="개인레슨 스케줄" />
      <div className="popup-body ap-dtl-pop">
        <div className="date-wrap">
          <div className="date">
            <span>{startDateText} </span>({getDwk(startDate.getDay())})
          </div>
          <div className="time">
            {startTime.ampm} {startTime.time} - {endTime.ampm} {endTime.time}
          </div>
        </div>
        <ApMember ScheduleVO={ScheduleVO} />
        <Memo
          title="스케줄 메모"
          placeHolder="스케줄 메모를 입력해주세요."
          memoContent={ScheduleVO.memo}
          memoReadOnly={memoReadOnly}
          onChangeMemo={handleChangeMemo}
          onClickUpdateMemo={handleClickUpdateMemo}
          onClickMemoPop={handleClickMemoPop}
        />
        {!isEmpty(PassVO) && (
          <div className="member-wrap">
            <div className="member-title">사용한 이용권</div>
            <Pass d={PassVO} isAdd={false} open={openPass} setOpen={setOpenPass} />
          </div>
        )}

        {PassVO.status === "AVAILABLE" ? (
          <div className="schedule-pop-btn">
            <div
              className={`cancel${ScheduleVO.scheduleState === "R" ? "" : " disable"}`}
              onClick={ScheduleVO.scheduleState === "R" ? handleOpenCancel : undefined}
            >
              예약취소
            </div>
            <div className="attendance" onClick={handleOpenAttendance}>
              출결 처리
            </div>
          </div>
        ) : (
          <div className="schedule-pop-btn-disable">출결처리 할 수 없는 이용권이에요.</div>
        )}

        <AppoinBtnPop
          d={ScheduleVO}
          ReservationSetting={ReservationSetting}
          setAttendanceState={setAttendanceState}
        />
        <AttendanceConfirm
          d={ScheduleVO}
          update={update}
          pass={PassVO}
          attendanceState={attendanceState}
        />
        <AbsentConfirm d={ScheduleVO} update={update} pass={PassVO} />
        <RsrvCancleConfirm d={ScheduleVO} update={update} pass={PassVO} />
      </div>
    </>
  );
};

export default AppointmentDtlPop;
